import orderBy from 'lodash/orderBy';

let dataTreeEndOfNode = [];

export function getTreeFromFlatData({ flatData, getKey = (node) => node.guid, getParentKey = (node) => node.parent_guid || null, rootKey = null, order = 'name' }) {
  if (!flatData) {
    return [];
  }

  const data = orderBy(
    flatData,
    [
      (element) => {
        if (element[order]) {
          return replaceSpecialChars(element[order].toLowerCase());
        }
        return element[order];
      },
    ],
    ['asc']
  );

  const childrenToParents = {};
  data.forEach((child) => {
    const parentKey = getParentKey(child);

    if (parentKey in childrenToParents) {
      childrenToParents[parentKey].push(child);
    } else {
      childrenToParents[parentKey] = [child];
    }
  });

  if (!(rootKey in childrenToParents)) {
    return [];
  }
  const trav = (parent) => {
    const parentKey = getKey(parent);
    if (parentKey in childrenToParents) {
      return {
        ...parent,
        children: childrenToParents[parentKey].map((child) => trav(child)),
      };
    }

    return { ...parent };
  };

  return childrenToParents[rootKey].map((child) => trav(child));
}

export const getListEndOfNode = (list) => {
  const data = getTreeFromFlatData({ flatData: list });
  dataTreeEndOfNode = [];

  return travelTree(data);
};

const travelTree = (items) => {
  for (let i in items) {
    if (items[i].children) {
      travelTree(items[i].children);
    } else {
      dataTreeEndOfNode.push(items[i]);
    }
  }

  return dataTreeEndOfNode;
};

const replaceSpecialChars = (string) => {
  let str = string.replace(/[ÀÁÂÃÄÅ]/, 'A');
  str = str.replace(/[àáâãäå]/, 'a');
  str = str.replace(/[ÈÉÊË]/, 'E');
  str = str.replace(/[Ç]/, 'C');
  str = str.replace(/[ç]/, 'c');

  // o resto

  return str.replace(/[^a-z0-9]/gi, '');
};
